import { AirConditioningMode } from '../domain/types';

export const airConditioningModeLabels: Record<AirConditioningMode, string> = {
  [AirConditioningMode.FREDDO]: 'Solo freddo',
  [AirConditioningMode.CALDO]: 'Solo caldo',
  [AirConditioningMode.FREDDO_CALDO]: 'Caldo/Freddo',
};
